import { render, staticRenderFns } from "./revolva.annotation.vue?vue&type=template&id=d5a188b0&scoped=true&"
import script from "./revolva.annotation.vue?vue&type=script&lang=ts&"
export * from "./revolva.annotation.vue?vue&type=script&lang=ts&"
import style0 from "./revolva.annotation.vue?vue&type=style&index=0&id=d5a188b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a188b0",
  null
  
)

export default component.exports